import isUndefined from "lodash/isUndefined";
import isEmpty from "lodash/isEmpty";
import { FormattedMessage } from "react-intl";
import { MAX_PASSENGERS_ALLOWED } from "app/constants";
import { toPassengerCount } from "app/utils/utils";

export const validateSearchEngine = ({ values = {}, isChildrenAgeRequired, adultOnly }) => {
	const errors = {};

	const {
		adults: adultsValue,
		infants: infantsValue,
		children: childrenValue,
		childrenBirthdates,
		infantsBirthdates,
	} = values;

	const adults = toPassengerCount(adultsValue);
	const infants = toPassengerCount(infantsValue);
	const children = toPassengerCount(childrenValue);

	if (adultOnly && (infants > 0 || children > 0)) {
		if (children > 0) {
			// highlight fields in red without field message
			errors.childrenBirthdates = [];
			[...Array(children)].forEach(() => errors.childrenBirthdates.push({}));
		}

		if (infants > 0) {
			// highlight fields in red without field message
			errors.infantsBirthdates = [];
			[...Array(infants)].forEach(() => errors.infantsBirthdates.push({}));
		}

		errors.formGlobalErrors = [
			{
				id: "error.passengers.with.children.infants.adult.only",
			},
		];
	}

	if (infants > adults) {
		errors.formGlobalErrors = [
			{
				id: "error.search.engine.infants.exceed.adults",
			},
		];
	}

	if (!adults) {
		errors.formGlobalErrors = [
			{
				id: "error.search.engine.adults.min",
			},
		];
	}

	if (infants + adults + children > MAX_PASSENGERS_ALLOWED) {
		errors.formGlobalErrors = [
			{
				id: "error.search.engine.max.passengers",
			},
		];
	}

	if (isChildrenAgeRequired) {
		if (childrenBirthdates) {
			childrenBirthdates.forEach((childrenBirthdate, index) => {
				if (
					isUndefined(childrenBirthdate.day) ||
					isUndefined(childrenBirthdate.month) ||
					isUndefined(childrenBirthdate.year)
				) {
					if (isEmpty(errors.childrenBirthdates)) {
						errors.childrenBirthdates = {};
					}
					errors.childrenBirthdates[index] = {
						id: "error.birthdate.required",
						values: {
							passenger: (
								<FormattedMessage
									values={{ index: index + 1 }}
									tagName="span"
									id="payment.passengers.child"
								/>
							),
						},
					};
				}
			});
		}

		if (infantsBirthdates) {
			infantsBirthdates.forEach((infantsBirthdate, index) => {
				if (
					isUndefined(infantsBirthdate.day) ||
					isUndefined(infantsBirthdate.month) ||
					isUndefined(infantsBirthdate.year)
				) {
					if (isEmpty(errors.infantsBirthdates)) {
						errors.infantsBirthdates = {};
					}
					errors.infantsBirthdates[index] = {
						id: "error.birthdate.required",
						values: {
							passenger: (
								<FormattedMessage
									values={{ index: index + 1 }}
									tagName="span"
									id="payment.passengers.infant"
								/>
							),
						},
					};
				}
			});
		}
	}

	return errors;
};
